<otw-home-banners-wrapper containerClass="!min-h-fit">
  @if(!isCategoryLoading()){
  <div class="flex flex-col gap-4">
    <h1 class="text-2xl md:text-3xl font-semibold px-6">Търсeне {{ selectedCategory()?.name }}</h1>
    <div class="w-full bg-lightGreen min-h-[400px] p-4 px-6 rounded-b-md">
      <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div class="md:col-span-2 lg:col-span-4 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          <otw-form-field label="Категория" for="category">
            <p-select inputId="category" [options]="categoryOptions()" formControlName="slug" class="w-full"
              size="small" [checkmark]="true" />
          </otw-form-field>
        </div>
        <otw-form-field label="Цена от" for="price_min">
          <p-inputnumber inputId="price_min" formControlName="price_min" mode="decimal" [minFractionDigits]="0"
            [maxFractionDigits]="2" class="w-full" size="small" />
        </otw-form-field>
        <otw-form-field label="Цена до" for="price_max">
          <p-inputnumber inputId="price_max" formControlName="price_max" mode="decimal" [minFractionDigits]="0"
            [maxFractionDigits]="2" class="w-full" size="small" />
        </otw-form-field>
        <otw-region-city-selector controlKey="regionCity" layout="horizontal" labelColor="white" inputSize="small"
          classNames="md:col-span-2 gap-4" containerClassNames="gap-4 flex-col md:flex-row"></otw-region-city-selector>

        @if(attributes().length>0){
        <ng-container formGroupName="attributes">
          @for(attribute of attributes(); track $index) {
          @let dataType = attribute.data_type; @let isOptionsField = dataType === "integer_option" || dataType ===
          "string_option";
          @let isMultiSelect = attribute.is_multiple_select;

          @if(isOptionsField && isMultiSelect)
          {
          @let options = dataType === "integer_option" ? attribute.integer_option : attribute.string_option;
          <otw-form-field [label]="attribute.name" class="md:col-span-2 lg:col-span-4 gap-4">
            <otw-checkbox-multiselect-form-field [formControlName]="attribute.id"
              containerClass="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 items-start" itemClass="items-center gap-4"
              [options]="toBaseOptions(options)">
            </otw-checkbox-multiselect-form-field>
          </otw-form-field>
          } @else if(isOptionsField){
          @let options = dataType === "integer_option" ? attribute.integer_option : attribute.string_option;
          <otw-form-field [label]="attribute.name" [for]="attribute.id">
            <!-- <p-select [options]="toBaseOptions(options)" [inputId]="attribute.id" [formControlName]="attribute.id"
              class="w-full" [showClear]="true" size="small" [checkmark]="true" /> -->
            <p-multiselect [options]="toBaseOptions(options)" [inputId]="attribute.id" [formControlName]="attribute.id"
              dataKey="value" optionLabel="label" optionValue="value" styleClass="w-full" size="small" display="chip"
              [showToggleAll]="false" />
          </otw-form-field>
          }@else if (dataType==="string") {
          <otw-form-field [label]="attribute.name" [for]="attribute.id">
            <input pInputText [name]="attribute.id" [formControlName]="attribute.id" class="w-full" pSize="small" />
          </otw-form-field>
          }@else if (dataType === "integer" ) {
          <otw-form-field [label]="attribute.name" [for]="attribute.id">
            <p-inputnumber [name]="attribute.id" [formControlName]="attribute.id" class="w-full" size="small" />
          </otw-form-field>
          }@else {
          <p class="text-red-500">No renderer found</p>
          }
          }
        </ng-container>
        }

        <!-- <p-button class="lg:hidden md:col-span-2" label="Търси" severity="primary" type="submit" styleClass="!w-full h-full" /> -->
        <otw-form-field label="Състояние" class="md:col-span-2">
          <otw-checkbox-multiselect-form-field formControlName="condition"
            containerClass="grid grid-cols-1 md:grid-cols-3 items-start" [options]="conditionOptions">
          </otw-checkbox-multiselect-form-field>
        </otw-form-field>

        <div class="md:col-span-2 lg:col-span-4 sm:grid lg:grid-cols-4 gap-4">
          <div class="lg:col-start-4 w-full h-full">
            <p-button label="Търси" severity="primary" type="submit" styleClass="!w-full h-[70px] mb-2 !uppercase" />
          </div>
        </div>
      </form>
    </div>
  </div>
  }@else {
  <div class="flex flex-col gap-4">
    <p-skeleton styleClass="!h-[36px] rounded-b-lg" class="w-full md:w-1/4" />
    <p-skeleton width="100%" styleClass="min-h-[400px] p-4 px-6 rounded-b-lg" />
  </div>
  }
</otw-home-banners-wrapper>